<h2>Überprüfen Sie Ihre Angaben</h2>
<p>
  Bitte überprüfen Sie untenstehende Angaben, bevor Sie Ihre Bestellung absenden.
</p>

<div id="printableSection">

  <table id="licenseData" style="width: 100%; margin-top: 1em; table-layout: fixed; border: 1px solid lightgrey" cellspacing="0" cellpadding="5">

    <tr style="background: lightgrey">
      <td style="width: 40%; text-align: left"><b>Lizenz</b></td>
      <td style="width: 60%"></td>
    </tr>

    <tr>
      <td colspan="2">{{organization.newLicenseTypeName}}</td>
    </tr>

    <tr>
      <td colspan="2">{{organization.newLicenseTypeDescription}}</td>
    </tr>

    <tr>
      <td>Preis</td>
      <td>{{organization.newLicensePriceNet | number:'1.2-2'}}</td>
    </tr>

    <tr>
      <td>MwSt</td>
      <td>{{organization.newLicenseTax | number:'1.2-2'}}</td>
    </tr>

    <tr>
      <td>Preis</td>
      <td>{{organization.newLicensePriceTotal | number:'1.2-2'}}</td>
    </tr>

    <tr>
      <td>Lizenzbeginn</td>
      <td>{{organization.formattedNewLicenseBeginDate}}</td>
    </tr>

  </table>

  <table id="companyData" style="width: 100%; margin-top: 1em; table-layout: fixed; border: 1px solid lightgrey" cellspacing="0" cellpadding="5">

    <tr style="background: lightgrey">
      <td style="width: 40%; text-align: left"><b>Lizenz wird ausgestellt f&uuml;r</b></td>
      <td style="width: 60%"></td>
    </tr>

    <tr>
      <td>Firma</td>
      <td>{{organization.organizationName}}</td>
    </tr>

    <tr>
      <td>Anrede</td>
      <td>{{organization.adminSalutation}}</td>
    </tr>

    <tr>
      <td>Vorname</td>
      <td>{{organization.adminFirstName}}</td>
    </tr>

    <tr>
      <td>Nachname</td>
      <td>{{organization.adminLastName}}</td>
    </tr>

    <tr>
      <td>Adresszeile 1</td>
      <td>{{organization.contactAddressLine1}}</td>
    </tr>

    <tr>
      <td>Adresszeile 2</td>
      <td>{{organization.contactAddressLine2}}</td>
    </tr>

    <tr>
      <td>PLZ</td>
      <td>{{organization.contactPostalCode}}</td>
    </tr>

    <tr>
      <td>Ort</td>
      <td>{{organization.contactCity}}</td>
    </tr>

    <tr>
      <td>Land</td>
      <td>{{toCountryName(organization.contactCountryCode)}}</td>
    </tr>

    <tr>
      <td>Email</td>
      <td>{{organization.contactEmail}}</td>
    </tr>

    <tr>
      <td>Telefon</td>
      <td>{{organization.contactPhone}}</td>
    </tr>

    <tr>
      <td>Bemerkungen</td>
      <td>{{organization.newLicenseRemarks}}</td>
    </tr>

  </table>

  <table id="billingData" style="width: 100%; margin-top: 1em; table-layout: fixed; border: 1px solid lightgrey" cellspacing="0" cellpadding="5">

    <tr style="background: lightgrey">
      <td style="width: 40%; text-align: left"><b>Rechnungsadresse</b></td>
      <td style="width: 60%"></td>
    </tr>

    <tr>
      <td>Firma</td>
      <td>{{organization.organizationName}}</td>
    </tr>

    <tr>
      <td>Adresszeile 1</td>
      <td>{{organization.billingAddressLine1}}</td>
    </tr>

    <tr>
      <td>Adresszeile 2</td>
      <td>{{organization.billingAddressLine2}}</td>
    </tr>

    <tr>
      <td>PLZ</td>
      <td>{{organization.billingPostalCode}}</td>
    </tr>

    <tr>
      <td>Ort</td>
      <td>{{organization.billingCity}}</td>
    </tr>

    <tr>
      <td>Land</td>
      <td>{{toCountryName(organization.billingCountryCode)}}</td>
    </tr>

    <tr>
      <td>Email</td>
      <td>{{organization.billingEmail}}</td>
    </tr>

    <tr>
      <td>Telefon</td>
      <td>{{organization.billingPhone}}</td>
    </tr>

  </table>

</div>

<p>
  Um die Bestellung abzuschliessen, klicken Sie auf "Bestellen". Die Bestellung ist dann definitiv und wird an SPR+ übermittelt.
</p>

<div class="buttonRow">
  <button (click)="appController.previous()">Zurück</button>
  <button (click)="print()">Ausdrucken</button>
  <button (click)="appController.submitLicenseRequest()" [disabled]="appController.licenseRequestSubmitted">Bestellen</button>
</div>
